module.exports = __webpack_public_path__ + "static/color element-32-59ecc07ab11513bc1a413c73306ada05.png";